import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CambioViaPagoPensionRoutingModule } from './cambio-via-pago-pension-routing.module';
import { CambioViaPagoHomeComponent } from './pages/cambio-via-pago-home/cambio-via-pago-home.component';
import { CambioViaPagoPensionService } from "./core/services/cambio-via-pago-pension.service";
import { SharedModule } from '@shared/shared.module';
import { CambioViaPagoComponent } from './pages/cambio-via-pago/cambio-via-pago.component';
import { CambioViaPagoDatosPersonalesComponent } from './pages/cambio-via-pago-datos-personales/cambio-via-pago-datos-personales.component';
import { ModalService } from '@services/modal/modal.service';
import { CambioViaPagoDatosBancariosComponent } from './pages/cambio-via-pago-datos-bancarios/cambio-via-pago-datos-bancarios.component';
import { CambioViaPagoConfirmarComponent } from './pages/cambio-via-pago-confirmar/cambio-via-pago-confirmar.component';
import { CambioViaPagoComprobanteComponent } from './pages/cambio-via-pago-comprobante/cambio-via-pago-comprobante.component';

@NgModule({
  imports: [
    CommonModule,
    CambioViaPagoPensionRoutingModule,
    SharedModule,
    CambioViaPagoDatosBancariosComponent
  ],
  declarations: [
    CambioViaPagoHomeComponent,
    CambioViaPagoComponent,
    CambioViaPagoDatosPersonalesComponent,
    CambioViaPagoConfirmarComponent,
    CambioViaPagoComprobanteComponent
  ],
  providers: [
    CambioViaPagoPensionService,
    ModalService,
  ]
})
export class CambioViaPagoPensionModule {}
